import { takeLatest, put, call } from 'redux-saga/effects';
import { handleResponse, get } from '../../dataFetching/remoteNew';

import * as actions from './actions';

function* getLoginUrlSaga({
  type,
  payload: {
    settings: { authorizationApi, clientId, loginCallback },
  },
}) {
  try {
    const result = yield get({
      url: `${authorizationApi}/security/get-login-url?clientId=${clientId}&redirectUri=${loginCallback}`,
    });

    const response = yield call(handleResponse, result);

    yield put(actions.getLoginUrlSuccess(response));
  } catch (e) {
    yield put(actions.getLoginUrlFailure({ type, message: e.message }));
  }
}

function* getLogoutUrlSaga({
  type,
  payload: {
    settings: { authorizationApi, logoutCallback },
  },
}) {
  try {
    const result = yield get({
      url: `${authorizationApi}/security/get-logout-url?redirectUri=${logoutCallback}`,
    });

    const response = yield call(handleResponse, result);

    yield put(actions.getLogoutUrlSuccess(response));
  } catch (e) {
    yield put(actions.getLogoutUrlFailure({ type, message: e.message }));
  }
}

function* getTokenDataSaga({
  type,
  payload: {
    code,
    settings: { authorizationApi, clientId, loginCallback },
  },
}) {
  try {
    const result = yield get({
      url: `${authorizationApi}/security/get-oss-token?code=${code}&clientId=${clientId}&redirectUri=${loginCallback}`,
    });

    const response = yield call(handleResponse, result);

    yield put(actions.getTokenDataSuccess(response));
    yield put(actions.loadUserRequest({ url: authorizationApi }));
  } catch (e) {
    yield put(actions.getTokenDataFailure({ type, message: e.message }));
  }
}

function* loadUserSaga({ type, payload: { url } }) {
  try {
    const result = yield get({ url: `${url}/security/info` });

    const response = yield call(handleResponse, result);

    yield put(
      actions.loadUserSuccess({
        user: response,
      })
    );
    yield put(actions.loadPermissionsRequest({ url }));
  } catch (e) {
    yield put(actions.loadUserFailure({ type, message: e.message }));
  }
}

function* loadPermissionsSaga({ type, payload: { url } }) {
  try {
    const result = yield get({ url: `${url}/security/get-permissions` });

    const response = yield call(handleResponse, result);

    yield put(
      actions.loadPermissionsSuccess({
        isAdmin: response.isAdmin,
        permissions: response.permissions,
      })
    );
  } catch (e) {
    yield put(actions.loadPermissionsFailure({ type, message: e.message }));
  }
}

function* checkTokenSaga({ type, payload: { token, settings } }) {
  try {
    const result = yield get({
      url: `${settings.authorizationApi}/security/check-token?token=${token}`,
    });

    const response = yield call(handleResponse, result);

    if (response - new Date().getTime() < 0) {
      yield put(actions.getLogoutUrlRequest({ settings }));
    } else {
      yield put(actions.checkTokenSuccess({ expiresOn: response }));
    }
  } catch (e) {
    yield put(actions.checkTokenFailure({ type, message: e.message }));
  }
}

export default [
  takeLatest(actions.getLoginUrlRequest, getLoginUrlSaga),
  takeLatest(actions.getLogoutUrlRequest, getLogoutUrlSaga),
  takeLatest(actions.getTokenDataRequest, getTokenDataSaga),
  takeLatest(actions.loadUserRequest, loadUserSaga),
  takeLatest(actions.loadPermissionsRequest, loadPermissionsSaga),
  takeLatest(actions.checkTokenRequest, checkTokenSaga),
];
